//@ts-ignore
import Siema from "siema";

import {isVisible, offset} from "./common";
import {lazyLoad} from "./lazy";


Siema.prototype.removeArrows = function (): void {
    this.prevArrow.remove();
    this.nextArrow.remove();
}

Siema.prototype.addArrows = function (): void {

    if (this.innerElements.length <= 1)
        return;

    this.prevArrow = document.createElement("button");
    this.nextArrow = document.createElement("button");
    this.prevArrow.className = "siema-prev";
    this.nextArrow.className = "siema-next";
    this.prevArrow.setAttribute("aria-label", "Immagine precedente");
    this.nextArrow.setAttribute("aria-label", "Immagine successiva");
    this.selector.parentNode.appendChild(this.prevArrow);
    this.selector.parentNode.appendChild(this.nextArrow);

    // event handlers on buttons
    this.prevArrow.addEventListener("click", (e: Event) => {
        e.stopPropagation();
        //this.config.duration = 0;
        //this.disableTransition();
        this.prev(1, function () {
            // let configs = this.config;
            // setTimeout(function () {
            //     configs.duration = 200;
            // }, 50);
        });
    });

    this.nextArrow.addEventListener("click", (e: Event) => {
        e.stopPropagation();
        //  this.config.duration = 0;
        //  this.disableTransition();
        this.next(1, function () {
            // let configs = this.config;
            // setTimeout(function () {
            //     configs.duration = 200;
            // }, 50);
        });
    });
};

Siema.prototype.loadBar = function (): void {

    if (this.innerElements.length === 1)
        return;

    this.bar = document.createElement("div");
    this.bar.className = "siema-bar";
    this.bar.style.width = `${100 / this.innerElements.length}%`;

    this.selector.appendChild(this.bar);
};

Siema.prototype.updateBar = function (): void {

    if (!this.bar)
        return;

    this.bar.style.left = `${this.currentSlide * 100 / this.innerElements.length}%`;
};

Siema.prototype.updateCounter = function (): void {

    if (!this.counter)
        return;

    this.counter.innerHTML = `${this.currentSlide + 1}/${this.innerElements.length}`;
};

Siema.prototype.addDots = function (): void {

    this.dots = document.createElement("div");
    this.dots.classList.add("siema-dots");

    for (let i = 0; i < this.innerElements.length; i++) {
        const dot = document.createElement("span");
        dot.classList.add("siema-dot");

        dot.addEventListener("click", () => {
            this.goTo(i);
        });

        this.dots.appendChild(dot);
    }

    this.selector.parentNode.insertBefore(this.dots, this.selector.nextSibling);

    this.updateDots();
};

Siema.prototype.updateDots = function (): void {

    const dots = this.dots.querySelectorAll(".siema-dot");

    for (let i = 0; i < dots.length; i++) {
        const addOrRemove = this.currentSlide === i ? "add" : "remove";
        dots[i].classList[addOrRemove]("active");
    }
};

Siema.prototype.lazyLoad = function (): void {

    const count = parseInt(this.selector.getAttribute("data-count"));
    const imageURLs = this.selector.getAttribute("data-URLs").split(",");

    if (!count || !imageURLs.length)
        return;

    const self = this;

    this.lazyLoad = {
        count: count,
        regex: /([^\s]+)(_\d)([^\s]+)/g,
        altRegex: /((Foto|Planimetria) )([0-9]+)/g,
        images: imageURLs
    };

    for (let i = 0, n = (count - this.innerElements.length); i < n; i++) {
        this.append(this.innerElements[0].cloneNode());
    }

    const cloneImage = (index: number): HTMLImageElement => {

        const img = self.innerElements[0].querySelector("img").cloneNode();

        const alt = img.getAttribute("alt");
        const src = img.getAttribute(img.hasAttribute("data-src") ? "data-src" : "src");
        const srcset = img.getAttribute(img.hasAttribute("data-srcset") ? "data-srcset" : "srcset");

        img.removeAttribute("src");
        img.removeAttribute("srcset");

        const chunks = self.lazyLoad.images[index].split(/_\d/);

        img.setAttribute("alt", alt.replace(self.lazyLoad.altRegex, `$1${index + 1}`));
        img.setAttribute("data-src", src.replace(self.lazyLoad.regex, `${chunks[0]}$2${chunks[1]}`));
        img.setAttribute("data-srcset", srcset.replace(self.lazyLoad.regex, `${chunks[0]}$2${chunks[1]}`));

        return img;
    };

    const fn = this.config.onChange;

    this.config.onChange = function (): void {

        if (self.currentSlide < 0)
            return;

        const cImg = self.innerElements[self.currentSlide].querySelector("img");

        if (!cImg) {
            const img = cloneImage(self.currentSlide);
            self.innerElements[self.currentSlide].appendChild(img);
            lazyLoad(img);
        }

        const nextIndex = self.currentSlide + (self.config.perPage["576"] || 1);
        const prevIndex = self.currentSlide > 0 ? self.currentSlide - 1 : self.innerElements.length - 1;

        if (nextIndex < self.innerElements.length && self.innerElements[nextIndex].childNodes.length === 0) {
            const img = cloneImage(nextIndex);
            self.innerElements[nextIndex].appendChild(img);
            lazyLoad(img);
        }

        if (prevIndex < self.innerElements.length && self.innerElements[prevIndex].childNodes.length === 0) {
            const img = cloneImage(prevIndex);
            self.innerElements[prevIndex].appendChild(img);
            lazyLoad(img);
        }

        this.updateCounter();

        if (fn)
            fn.call(this);
    };

    this.config.onChange.call(this);

};

Siema.prototype.addThumbnails = function (): void {

    const self = this;

    this.thumbnails = document.createElement("div");
    this.thumbnails.className = "siema-thumbnails c-scrollbar";

    const row = document.createElement("div");
    row.className = "row flex-nowrap";

    const count = parseInt(this.selector.getAttribute("data-count"));

    for (let i = 0; i < count; i++) {

        const imgWrapper = self.innerElements[0].cloneNode(true);

        const img = imgWrapper.querySelector("img");

        const alt = img.getAttribute("alt");
        const src = img.getAttribute(img.hasAttribute("data-src") ? "data-src" : "src");
        const srcset = img.getAttribute(img.hasAttribute("data-srcset") ? "data-srcset" : "srcset");

        img.setAttribute("alt", alt.replace(self.lazyLoad.altRegex, `$1${i + 1}`));
        img.setAttribute("src", src.replace(self.lazyLoad.regex, `$1${i + 1}`));
        img.setAttribute("srcset", srcset.replace(self.lazyLoad.regex, `$1${i + 1}`));

        const col = document.createElement("div");
        col.className = "col-auto col-thumbnail";

        col.addEventListener("click", () => {
            this.goTo(i);
        });

        col.appendChild(imgWrapper);

        row.appendChild(col);
    }

    this.thumbnails.appendChild(row);

    const fn = this.config.onChange;

    this.config.onChange = function (): void {

        if (fn)
            fn.call(this);

        [].slice.call(self.thumbnails.childNodes[0].childNodes).forEach((thumbnail: HTMLElement, index: number) => {

            if (index === self.currentSlide) {
                thumbnail.classList.add("active");
                if (!isVisible(thumbnail, true)) {

                    const parentNode: Node | null = thumbnail.parentNode ? thumbnail.parentNode.parentNode : null;

                    if (parentNode) {
                        const offsetRect = offset(thumbnail, parentNode);

                        if (offsetRect.left > 0)
                            (parentNode as HTMLElement).scrollLeft += offsetRect.right;
                        else {
                            (parentNode as HTMLElement).scrollLeft += offsetRect.left;
                        }
                    }
                }
            } else
                thumbnail.classList.remove("active");
        });

    };

    this.selector.parentNode.parentNode.insertBefore(this.thumbnails, this.selector.parentNode.nextSibling);
};

export default Siema;